import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_eqjsm2jrcg: FaireCollectionEntity = {
  token: "pbc_eqjsm2jrcg",
  type: "collection",
  name: "In-Stock Baby Dresses (Sweater Knits)",
  heroImageUrl:
    "https://cdn.faire.com/fastly/af063a96f2423d930946c36c672e3db2f79f8656b8d61f91c75fa7725bb42c05.jpeg",
  itemCount: 40,
  description:
    "Discover our in-stock collection of organic cotton baby sweater knit dresses, thoughtfully designed with soft textures, delicate details, and timeless charm. Ready to ship, these cozy styles are perfect for everyday wear and special occasions.\n",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:19.831Z",
    importedBy: "entity-db-import-collections",
  },
};
